import { cn } from '@/utils';

const PrimaryButton = ({
  children,
  className,
  activeClassName,
  hoverClassName,
  disabledClassName,
  small,
  medium,
  large,
  xlarge,
  ...props
}) => {
  let sizeCss = '';

  if (small) {
    sizeCss = 'px-2.5 py-1.5 text-xs rounded';
  } else if(medium) {
    sizeCss ='px-3 py-2 text-sm rounded-md leading-4';
  }  else if(large) {
    sizeCss ='px-4 py-2 text-base rounded-md';
  }  else if(xlarge) {
    sizeCss ='px-xl py-3 text-base rounded-md';
  }

  let color = 'text-white !bg-[color:var(--theme-color)] !border-[color:var(--theme-color)]';
  let colorHover = 'hover:text-[color:var(--theme-color)]';
  let colorActive = 'focus:text-[color:var(--theme-color)]';

  return (
    <button
      className={
        cn(
          "button w-full",
          sizeCss,
          className,
          color,
          colorHover, hoverClassName,
          colorActive, activeClassName,
          'disabled:opacity-40 disabled:cursor-not-allowed disabled:pointer-events-none', disabledClassName
        )}
      {...props}
    >
      {children}
    </button>
  );
};

export default PrimaryButton;
